import React from 'react';
import { Link } from 'react-router-dom';
import '../components/audit/audit.css';
import AuditHistoryList from '../components/audit/AuditHistoryList';

export default function AuditHistoryPage() {
  return (
    <div className="page audit-history-page">
      <header className="audit-history-header">
        <h1>Parking Audits</h1>
        <Link to="/sales/audits/new" className="audit-btn primary">+ New Audit</Link>
      </header>
      <AuditHistoryList />
    </div>
  );
}
